import { faComments } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useInstantSearch } from "react-instantsearch";
import { useNavigate } from "react-router-dom";
import { useAccount, useWorkspaces } from "../state";
import { fromIndexUiState } from "../workspace/criteria";
import { explorationName } from "../workspaces/names";

// Maakt een verkenning met het filter dat nu op /search staat en opent hem.
// Alleen met de workspace-feature; Zoek zelf blijft voor iedereen.
export const ExploreWithChat = () => {
  const chatEnabled = useAccount((s) => s.user?.features?.workspace);
  const createWorkspace = useWorkspaces((s) => s.createWorkspace);
  const { indexUiState } = useInstantSearch();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  if (!chatEnabled) return null;

  const start = async () => {
    setBusy(true);
    setError(undefined);
    const criteria = fromIndexUiState(indexUiState as any);
    const exploration = await createWorkspace(explorationName(criteria, new Date()), {
      criteria,
    });
    setBusy(false);
    if (!exploration) {
      setError("Kon de verkenning niet aanmaken");
      return;
    }
    navigate(`/workspace/${exploration.id}`);
  };

  return (
    <div className="px-2 pb-2">
      <button
        type="button"
        onClick={start}
        disabled={busy}
        className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-green px-3 py-2 text-sm font-medium text-dark-green hover:bg-green hover:text-white disabled:opacity-50"
        title="Maak een verkenning met dit filter en zoek verder met de chat"
      >
        <FontAwesomeIcon icon={faComments} />
        {busy ? "Verkenning maken…" : "Zoeken met chat"}
      </button>
      {error && <p className="pt-1 text-xs text-red-600">{error}</p>}
    </div>
  );
};
